<template>
    
    <div class="customer_infos">
         <div class="search-reports" @mouseover="OperatingWebsite()">
       
       <banner>
            <img src="../assets/images/searchbackground.jpg"/>
            <div slot="title">{{$t('NavabarText.navbar_searchy')}}</div>
        </banner>
        <div class="steps_group">
            <el-steps direction="vertical" :active="activeSteps" finish-status="success">
                <el-step title="樣本運送途中" />
                <el-step title="檢測前準備" />
                <el-step title="離心提取" />
                <el-step title="上機檢測" />
                <el-step title="核對檢測數據" />
                <el-step title="二次核發檢測數據" />
                <el-step title="簽發報告" />
            </el-steps>
        </div>
         </div>
        
    </div>
</template>

<script>
import banner from '@/components/banner'

export default {
     data(){
        return{
                activeSteps:1,
                dateTime:''
        }
     },
    components: {
      banner,
     
    },
    mounted(){
        this.dateTime=this.$route.query.dateTime
        console.log('dateTime',this.dateTime)
        this.initSteps();
    },
     methods:{
        //根据时间 计算检验进度
        initSteps(){
            //样本运送途中  检测前准备 120分钟（2小时）   离心提取 60分钟（3 小时）  上机检测 240分钟（7小时）  核对检测数据 60分钟（8小时）  二次合法检测数据 120分钟（10小时）  签发报告 下载word 报告后480分钟（18小时）
            //0   2小时  3 小时  7小时  8小时 10小时 18小时
            if(this.dateTime!=null&&this.dateTime!=''&&this.dateTime!=undefined){
                let currentDateTime=new Date();
                let postCheckDateTime=new Date(this.dateTime)
                var dateDiff=currentDateTime.getTime()-postCheckDateTime.getTime();//相差的毫秒数
                var leaveHours=dateDiff/(3600*1000);//相差多少小时
                console.log(leaveHours,'leaveHours')
                if(leaveHours<2){
                    this.activeSteps=1;
                }else if(leaveHours>=2&&leaveHours<3){
                    this.activeSteps=2
                }else if(leaveHours>=3&&leaveHours<7){
                    this.activeSteps=3
                }else if(leaveHours>=7&&leaveHours<8){
                    this.activeSteps=4
                }else if(leaveHours>=8&&leaveHours<10){
                    this.activeSteps=5
                }else if(leaveHours>=10&&leaveHours<18){
                    this.activeSteps=6
                }else if(leaveHours>=18){
                    this.activeSteps=7
                }
            }
        },
        OperatingWebsite(){
            let currentTime = this.currentTime;
            let lastTime = new Date().getTime();
            let timeOut = 10 * 60 * 1000; //设置时间 10分钟
            if (lastTime - currentTime > timeOut) {
            // 未操作页面，跳转登录页面
            this.currentTime = new Date().getTime();
            const fullPath = this.$route.fullPath;
            let query=fullPath;
            this.$confirm('您当前页面停留时间过长，请刷新', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                location.reload();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消当前操作！'
                });          
            });
            
            } else {
            this.currentTime = new Date().getTime();
        }
      },
     },
}


</script>

<style scoped>
.search-reports{
    width: 100%;
   
    margin-top:1rem;
    text-align: center;
    position: relative;   
    .search-img{
       margin:0 auto;
       .img-ss{
           position: relative;
            .search-background{
                max-width: 100%;
                height: auto;
                position: relative;
            }
            .search-title{
                    width:100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: bold;
                    top:0;
            }
            .search-title:before{
                display: table;
                content:" ";
            }
            .search-title:after{
                display: table;
                content:" ";
            }
            
       }
       
    }
}
.customer_infos {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
  .logo_header {
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
  }
    .logo_image {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      height: 70px;
    }
    img {
      width: 100% !important;
      height: 100% !important;
    }
  

  .steps_group{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:80px;
    height: 600px;
    margin-bottom: 80px;
  }



</style>


// WEBPACK FOOTER //
// src/view/steps.vue